import { render, staticRenderFns } from "./NirAmendmentsTaskQueue.vue?vue&type=template&id=63babd60&scoped=true&"
import script from "./NirAmendmentsTaskQueue.vue?vue&type=script&lang=js&"
export * from "./NirAmendmentsTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./NirAmendmentsTaskQueue.vue?vue&type=style&index=0&id=63babd60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63babd60",
  null
  
)

export default component.exports